import { createContext } from 'use-context-selector';

import { type DialogContextProps } from './DialogContextProvider.types';

import { notImplemented } from 'utils/notImplemented';

const initialData: DialogContextProps = {
  isDialogOpen: false,

  closeDialog: notImplemented,
  openDialog: notImplemented,
  getMousePosition: notImplemented,
};

export const DialogContext = createContext(initialData);
